<template>
	<div class="register-warapper">
		<div class="register-conter">
			<div class="left">
				<div class="left-img" @click="$router.push('/')">
					<img src="@/assets/images/registerLogin.png" alt="">
				</div>
				<div class="loop-shop">成为我们的 LOOPSHOP 商户</div>
				<div class="account flex-start">
					<div class="left-text">已有帐户？</div>

					<div @click="gotologin" class="right-text">登入</div>


				</div>
				<div class="submit-form">

					<div class="from">
						<div class="label">电邮</div>
						<input class="from-input" type="text" placeholder="请输入电邮" v-model="submitForm.email" required>
					</div>
					<div class="container">
						<div class="label">电话号码</div>
						<div class="selet-input">
							<div class="select-left">
								<select v-model="submitForm.selectedOption" class="select">
									<option value="852">+852</option>
									<option value="86">+86</option>
									<option value="886">+886</option>
								</select>
							</div>
							<div class="input-right">
								<input class="right-input" type="text" v-model="submitForm.mobile" placeholder="请输入手机号码">
							</div>
						</div>
					</div>
					<div class="from-password">
						<div class="label">密码</div>
						<div class="from-input">
							<input style="font-size: 0.26rem;"   :type="type" placeholder="您的密码" v-model="submitForm.password" required>
							<img src="@/assets/images/eye.png" @click="type = type == 'password' ? 'text' : 'password'"
								class="icon" alt="">
						</div>
						<p style="font-size:0.18rem;color:black">必须包含数字、小写、大写字母，最短8位，最长20位</p>

					</div>
					<div class="from-password">
				<div class="label">确认密码</div>
				<div class="from-input">
					<input style="font-size: 0.26rem;"   :type="type" placeholder="重新填写您的密码" v-model="submitForm.repassword" required>
					<img src="@/assets/images/eye.png" @click="type = type == 'password' ? 'text' : 'password'"
						class="icon" alt="">
				</div>

					</div>
					<div class="check">
						<input type="checkbox" v-model="isChecked" style="width: 20px; height: 20px;"
							:class="{ 'red-text': isChecked }">
						<div class="text">我同意</div>
						<div @click="gotourl" class="term underline">LOOPSHOP服务条款</div>
					</div>
					<button v-if="!checking" class="custom-button" @click="establish">建立帐户</button>
					<button v-if="checking" class="custom-button"  >正在验证</button>

				</div>
			</div>
			<div class="right">
				<img src="@/assets/images/register.png" alt="">
			</div>
		</div>
		<BaseFooter></BaseFooter>
	</div>
</template>
<script>
export default {
	name: 'Regist',
	data() {
		return {
			submitForm: {
				phone: '',
				email: '',
				selectedOption: '852',
				password: '',
				repassword: '',
			},
			type: 'password',
			isChecked: false,
			checking:false 
		}
	},
	created(option) {
		const partner_id = this.$getStorage('partner_id')
	 
			console.log('partner_id:', partner_id)
		
	},
	methods: {

			
		gotologin() {
			window.location.href = 'https://merchants.loopshop.com.hk/'
		},
		async checkEmail() {
			
			let fdata = { do: 'testEmail', email: this.submitForm.email }
			let res = await this.$api.funk(fdata)
			console.log('res0', res);
			console.log('res0', res.emailExists);
			if (res.emailExists) {
				console.log('email is here');
				this.checking = false
				this.$message.error('电邮已经被使用，不能重复注册，请使用其他电邮地址重新尝试。');
			} else {
				//send email 
				let bstr = this.sendEmail()
				console.log('sendemail', bstr);

			}

			//return res 
		},
		async sendEmail() {

			let fdata = { do: 'Send_email_otp', email: this.submitForm.email }
			let res = await this.$api.funk(fdata)
			if (res.retDescr == 'Success') {
				res.submitForm = this.submitForm
				this.$setStorage('localdata', res)
				this.checking = false
				this.$router.push({ path: '/code' })
			} else {
				this.checking = false
				console.log('error send email ');
			}
		},
		toggleCheckbox() {
			this.isChecked = !this.isChecked;
			console.log(1)
			console.log(this.isChecked)
		},
		isEmailValid(email) {
			// const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			const emailPattern = /^[^\s@]+(\.[^\s@]+)*@[^\s@]+\.[^\s@]+$/;
			return emailPattern.test(email);
		},
		
		establish() {
			console.log('login~');

			if(this.checking){
				console.log('checking....')
				return 
			}

			if (!this.isChecked){
				this.$message.error('请先同意服务条款');
				return 
			}

			if(this.submitForm.selectedOption == '86'){
				if(this.submitForm.mobile.length != 11){
					this.$message.error('电话号码长度不正确');
					return 
				}
			}else{
				if(this.submitForm.mobile.length != 8){
					this.$message.error('电话号码长度不正确');
					return 
				}
			}

			if(!this.isEmailValid(this.submitForm.email)){
				console.log('邮箱格式不对')
				this.$message.error('电邮格式不正确');
				return 
			}
			 const regex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,20}$/;
			
			  if (regex.test(this.submitForm.password)) {
					console.log('password ok')
			  } else {
				 const $msg =  "密码必须包含数字、小写、大写字母，最短8位，最长20位";
				  this.$message.error($msg);
				  return 
			  }
	 
			

			if(this.submitForm.password != this.submitForm.repassword){
				this.$message.error('两次输入的密码不一致');
				return 
			}
			if (this.submitForm.email && this.submitForm.mobile && this.submitForm.password) {
				console.log('check');
				this.checking = true 
				this.checkEmail()
				//this.$router.push({ path: '/code' })
 
			} else {
				console.log('error');
			}
		},
		gotourl() {
			this.$router.push({ name: 'privacy', params: { id: 16 } })
		}
	}

}
</script>
<style lang="scss" scoped>
.underline:hover {
	cursor: pointer;
	text-decoration: underline;
}

.register-warapper {
	padding: 0.24rem 0.24rem 0.24rem 0.4rem;
}

.register-conter {
	display: flex;
	width: 100%;
	height: 98%;
	justify-content: flex-end;



	.left {
		margin-right: 2.6rem;

		.left-img {
			// width: 1.4rem;
			height: 0.48rem;
			position: absolute;
			left: 0.4rem;
			cursor: pointer;

			img {
				height: 100%;
				display: block;
			}
		}

		.loop-shop {
			padding-top: 1.8rem;
			font-family: 'Microsoft YaHei';
			font-style: normal;
			font-weight: 600;
			font-size: 0.4rem;
			line-height: 0.56rem;
			color: #000000;
		}

		.account {
			display: flex;
			align-items: center;

			.left-text {
				font-family: 'Microsoft YaHei';
				font-style: normal;
				font-weight: 400;
				font-size: 0.26rem;
				line-height: 0.28rem;
				color: #666666;
			}

			.right-text {
				font-family: 'Microsoft YaHei';
				font-style: normal;
				font-weight: 600;
				font-size: 0.26rem;
				line-height: 0.28rem;
				text-decoration-line: underline;
				color: #E02E43;
				cursor: pointer;
			}
		}

		.submit-form {
			.from {
				margin-top: 0.64rem;
				margin-bottom: 0.32rem;

				.label {
					font-family: 'Microsoft YaHei';
					font-style: normal;
					font-weight: 400;
					font-size: 0.26rem;
					line-height: 0.28rem;
					text-align: initial;
					color: #000000;
					margin-bottom: 0.08rem;
				}

				.from-input {
					width: 5.22rem;
					background: #FAFAFA;
					border: 1px solid #999999;
					border-radius: 0.08rem;
					padding: 0.16rem;
					display: block;

					font-size: 0.28rem;

					&::-webkit-input-placeholder {
						color: #ccc;
					}


				}
			}

			.from-password {
				margin-top: 0.32rem;
				margin-bottom: 0.32rem;

				.label {
					font-family: 'Microsoft YaHei';
					font-style: normal;
					font-weight: 400;
					font-size: 0.26rem;
					line-height: 0.28rem;
					text-align: initial;
					color: #000000;
					margin-bottom: 0.08rem;
				}

				.from-input {
					width: 5.22rem;
					background: #FAFAFA;
					border: 1px solid #999999;
					border-radius: 0.08rem;
					padding: 0.16rem;
					display: block;
					display: flex;
					justify-content: space-between;
					align-items: center;

					&::-webkit-input-placeholder {
						color: #ccc;
					}


					input:-webkit-autofill,
					textarea:-webkit-autofill,
					select:-webkit-autofill {
						-webkit-text-fill-color: #fff !important;
						-webkit-box-shadow: 0 0 0px 1000px transparent inset !important;
						background-color: transparent;
						background-image: none;
						transition: background-color 50000s ease-in-out 0s;
					}


					.icon {
						width: 0.3rem;
						height: 0.3rem;
						cursor: pointer;
					}

					input {
						background: #FAFAFA;
						font-size: 0.26rem;

						&::-webkit-input-placeholder {
							color: #ccc;
						}

						width: 100%;
						height: 100%;
					}
				}


			}

			.check {
				display: flex;
				align-items: center;

				.text {
					font-family: 'Microsoft YaHei';
					font-style: normal;
					font-weight: 400;
					font-size: 0.26rem;
					line-height: 0.28rem;
					margin-left: 0.11rem;
					color: #000000;

				}

				.term {
					font-family: 'Microsoft YaHei';
					font-style: normal;
					font-weight: 600;
					font-size: 0.26rem;
					line-height: 0.28rem;
					color: #E02E43;
					margin-left: 0.04rem;
				}
			}

			.custom-button {
				background: #E02E43;
				border-radius: 0.08rem;
				font-family: 'Microsoft YaHei';
				font-style: normal;
				font-weight: 600;
				font-size: 0.24rem;
				line-height: 0.32rem;
				color: #FFFFFF;
				width: 100%;
				line-height: 0.8rem;
				height: 0.8rem;
				margin-top: 0.65rem;
				cursor: pointer;
			}

			.container {
				margin: 0;

				.label {
					font-family: 'Microsoft YaHei';
					font-style: normal;
					font-weight: 400;
					font-size: 0.2rem;
					line-height: 0.28rem;
					text-align: initial;
					color: #000000;
					margin-bottom: 0.08rem;
				}

				.selet-input {
					width: 5.22rem;
					background: #FAFAFA;
					border: 1px solid #999999;
					border-radius: 0.08rem;
					display: flex;
					height: 0.52rem;

					.select-left {
						border-right: 1px solid #999999;
						line-height: 0.52rem;
						padding: 0 0.1rem;

						.select {
							background: #FAFAFA;
							width: 1.13rem;
							line-height: 0.52rem;
							font-size: 0.26rem;
							height: 100%;
							display: block;
						}
					}


					.input-right {
						width: 80%;
						height: 100%;

						input {
							width: 100%;
							height: 100%;
							display: block;
							padding: 0 0.18rem;

							&::-webkit-input-placeholder {
								color: #ccc;
							}
						}

						.right-input {
							border-radius: 0.08rem;
							width: 100%;
							height: 100%;
							font-size: 0.28rem;
							background: #FAFAFA;
						}
					}
				}

			}

		}
	}

	.right {
		border-radius: 0.4rem;
		width: 7.76rem;
		// height: 96vh;
		border-radius: 0.3rem;
		overflow: hidden;

		img {
			height: 100%;
			width: 100%;
			object-fit: cover;
			display: block;
		}
	}
}

@media (max-width: 750px) {
	.register-conter {
		display: block;
		width: 100%;
		padding: 0.4rem;
	}

	.register-warapper {
		padding: 0;
	}

	.register-conter .right {
		display: none;
	}

	.register-conter .left .left-img {
		height: 0.8rem;
	}

	.register-conter .left .loop-shop {
		width: 100%;
	}

	.register-conter .left {
		margin: 0;
	}

	.register-conter .left .account {
		margin-top: 0.16rem;
	}

	.register-conter .left .submit-form .from .label,
	.register-conter .left .submit-form .container .label,
	.register-conter .left .submit-form .from-password .label {
		font-size: 0.32rem;
		line-height: 0.32rem;
		margin-bottom: 0.2rem;
	}

	.register-conter .left .submit-form .from .from-input,
	.register-conter .left .submit-form .container .selet-input,
	.register-conter .left .submit-form .from-password .from-input {
		width: 100%;
		height: 0.9rem;
	}

	.register-conter .left .submit-form .check .text {
		font-size: 0.26rem;
		line-height: 0.26rem;
		display: block;
	}

	.register-conter .left .submit-form .check .term {
		font-size: 0.26rem;
		line-height: 0.26rem;
		display: block;
	}

	.register-conter .left .submit-form .check {
		align-items: center;
	}

	.register-conter .left .submit-form .custom-button {
		background: #E02E43;
		border-radius: 0.16rem;
		height: 1rem;
		font-family: "Microsoft YaHei";
		font-style: normal;
		font-weight: 600;
		font-size: 0.4rem;
		line-height: 0.32rem;
		color: #FFFFFF;
		width: 100%;
		line-height: 0.8rem;
		cursor: pointer;
	}
}
</style>